import useBreakpoint from 'src/shared/hooks/use-breakpoint'
import { useWindowScrollBreakpoint } from 'src/shared/hooks/use-window-scroll-breakpoint'
import { cn } from 'src/shared/utils/cn'

import { useUserByUsername } from '../../../api/accounts/use-user-by-username'
import ProfileStartJourneyBtn from '../../start-journey-btn/profile-start-journey-btn'

/**
 * Displays the profile start journey button.
 * If the user doesn't have a profile workflow available, the footer is hidden.
 */
export default function PublicUserProfileFooter({ username }: { username: string }) {
  const { isMobile } = useBreakpoint()
  const { data: user } = useUserByUsername(username || '')
  const profileWorkflowAvailable = user?.firstConversationWorkflowAvailable ?? false
  const scrolledToBottom = useWindowScrollBreakpoint({ breakpoint: 5, reverse: true })

  return (
    <div
      className={cn(
        'fixed inset-x-5 bottom-[23px] z-20 flex justify-center xs:bottom-[42px]',
        // If the user doesn't have profile workflow available, the footer is hidden.
        !profileWorkflowAvailable && 'hidden',
        isMobile && 'inset-x-0 bottom-0 bg-white px-5 pb-7 pt-4',
        isMobile && !scrolledToBottom && 'border-t border-lightBorder shadow-[0_-5px_12px_0_rgba(27,48,41,0.035)]',
      )}
    >
      <ProfileStartJourneyBtn className="w-full xs:w-[250px]" username={username} />
    </div>
  )
}
